export default {
  de: {
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'Email',
    create: 'Benutzer hinzufügen',
  },
};
